define('detectPrint',['jquery'],

function($){

	$('.wide-bg-container[data-mobilsrc]').each(function(){
		if ($(this).find('.contact-hero').length < 1){
			return;
		}
		var $this = $(this),
			thisSrc = $this.data('mobilsrc'),
			thisImg = '<img class="printimage" src="' + thisSrc + '">';
		var beforePrint = function() {
			$this.prepend(thisImg);
		};
		var afterPrint = function() {
			$('.printimage').remove();
		};



		if (window.matchMedia) {
			var mediaQueryList = window.matchMedia('print');
			mediaQueryList.addListener(function(mql) {
				if (mql.matches) {
					beforePrint();
				} else {
					afterPrint();
				}
			});
		}

		window.onbeforeprint = function(){$this.prepend(thisImg);};
		window.onafterprint = function(){$('.printimage').remove();};
		/*window.onbeforeprint = beforePrint;
		window.onafterprint =	afterPrint;*/
	});
});
